import React from 'react';

import {TRANSFORMATION_STEP_TYPES} from 'analysis-tool/AnalysisToolConstants';
import {AnalysisGraphQL, GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {
  getDataFrameFilterOptionsForView,
  getFilterWithMetadataForStep,
} from 'analysis-tool/filters/GetDataFrameFilterOptions';
import FilterPill from 'data-frames/filters/components/FilterPill';
import {PipelineStepStatusCode, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import TransformPill from './TransformPill';

export function getTransformPillSteps(steps: Array<GetAnalysisPipelineStep>): Array<GetAnalysisPipelineStep> {
  return steps.filter((step) => TRANSFORMATION_STEP_TYPES.includes(step.definition.stepType));
}

export function getTransformPills(
  analysis: AnalysisGraphQL,
  viewSteps: Array<GetAnalysisPipelineStep>
): Array<JSX.Element> {
  const pills: Array<JSX.Element> = [];
  const {filterOptions} = getDataFrameFilterOptionsForView(analysis, viewSteps);
  for (const step of getTransformPillSteps(viewSteps)) {
    if (step.definition.stepType !== PipelineStepType.FILTER_DATASET) {
      pills.push(<TransformPill analysis={analysis} step={step} />);
    }
    if (step.definition.stepType === PipelineStepType.FILTER_DATASET) {
      for (const filterWithMetadata of getFilterWithMetadataForStep(analysis, step)) {
        pills.push(
          <FilterPill
            key={filterWithMetadata.filterId}
            filterWithMetadata={filterWithMetadata}
            filterOptions={{
              getFilterForColumnHeaders: (columnSystemName: string) =>
                filterOptions.getFilterForColumn(columnSystemName, filterWithMetadata.filterId),
              updateFilterForColumn: (columnSystemName, newFilter) =>
                filterOptions.updateFilterForColumn(columnSystemName, newFilter, filterWithMetadata.filterId),
              dataFrameSpec: filterWithMetadata.dataFrameSpec,
              getUnfilteredColumns: filterOptions.getUnfilteredColumns,
            }}
            readOnlyInfo={filterWithMetadata.readOnlyInfo}
            onDelete={() =>
              filterOptions.updateFilterForColumn(
                filterWithMetadata.filter.filters[0].columnSystemName,
                null,
                filterWithMetadata.filterId
              )
            }
            disabled={
              ![PipelineStepStatusCode.SUCCEEDED, PipelineStepStatusCode.FAILED].includes(step.statusCode)
            }
          />
        );
      }
    }
  }
  return pills;
}
